import definition from './events.service';

/**
 * EventsApi settings
 * @type {{name: string, definition: EventsApi}}
 */
export default {
    name: 'EventsApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/events/index.js